import { PermissionCheck } from '@/types';

export function checkCondition<T extends { [key: string]: any }>(permissionsObject: T, condition: PermissionCheck<T>) {
    if (typeof condition === 'string' && permissionsObject[condition] === true) {
        return true;
    } else if (typeof condition === 'function' && condition(permissionsObject) === true) {
        return true;
    }

    return false;
}